import PropTypes from 'prop-types'
import React from 'react'

import ProgramFlagCheckbox from './ProgramFlagCheckbox'

class ProgramFlagFilter extends React.Component {
  handleChange = (evt) => {
    // we clone flags-object here in order to make equality comparison fail.
    // Otherwise a change in a flag (an attribute of the flags-props object)
    // will NOT change the object-id itself, and therefore other functions
    // will not be able to detect the change without iterating through each key-value
    // pair!
    //
    // see: SchNetProgramsApp#handleFilterChange
    let flags = Object.assign({}, this.props.flags)
    let field = evt.target
    let checked = field.checked
    flags[field.name] = checked
    this.props.onChange(flags)
  }

  render () {
    return (
      <React.Fragment>
        <div className="row">
          <fieldset className='col-md-6'>
            <strong className='d-inline-block mb-2'>Optionen / Leistungen</strong>
            <ProgramFlagCheckbox name='siblings_discount'
                                 label='Geschwisterrabatt'
                                 checked={this.props.flags.siblings_discount}
                                 onChange={this.handleChange}
            />
            <ProgramFlagCheckbox name='own_guest_family_discount'
                                 label='eigene Gastfamilie'
                                 checked={this.props.flags.own_guest_family_discount}
                                 onChange={this.handleChange}
            />

            <ProgramFlagCheckbox name='scholarships'
                                 label='Stipendien'
                                 checked={this.props.flags.scholarships}
                                 onChange={this.handleChange}
            />
            <ProgramFlagCheckbox name='placement_guaranty'
                                 label='Platzierungsgarantie'
                                 description='Soll die Organisation vertraglich die Platzierung im Schüleraustauschprogramm zusichern?'
                                 containerRef={this.props.containerRef}
                                 checked={this.props.flags.placement_guaranty}
                                 onChange={this.handleChange}
            />
            <ProgramFlagCheckbox name='travel_offer'
                                 label='Reiseangebote Gastland'
                                 description='Soll die Organisation im Gastland Reiseangebote gegen Aufpreis unterbreiten? Genauere Informationen in der Anbieterbroschüre.'
                                 containerRef={this.props.containerRef}
                                 checked={this.props.flags.travel_offer}
                                 onChange={this.handleChange}
            />
            <ProgramFlagCheckbox name='airport_intro'
                                 label='Flughafeneinweisung'
                                 description='Soll die Organisation am Abflughafen eine Einweisung der Programmteilnehmer anbieten? Genauere Informationen in der Anbieterbroschüre.'
                                 containerRef={this.props.containerRef}
                                 checked={this.props.flags.airport_intro}
                                 onChange={this.handleChange}
            />
            <ProgramFlagCheckbox name='accompanied_flight'
                                 label='Begleiteter Flug'
                                 description='Soll die Organisation für Gruppen ab 15 Teilnehmern den Flug begleiten? Genauere Informationen in der Anbieterbroschüre.'
                                 containerRef={this.props.containerRef}
                                 checked={this.props.flags.accompanied_flight}
                                 onChange={this.handleChange}
            />
          </fieldset>
          <fieldset className='mb-3 col-md-6'>
            <strong className='d-inline-block mb-2'>Vor-/Nachbereitung</strong>
            {/* NOTE: we should think about using React Context
                for access to the top-level DOM container reference.
                Otherwise every potential InfoPopup in nested components
                forces all other components in the hierarchy above to have a
                `containerRef` prop, as seen below.

                see: https://reactjs.org/docs/context.html */}
            <ProgramFlagCheckbox name='prep_meeting'
                                 label='incl. Vorbereitungstreffen'
                                 description='Soll im Preis eine Vorbereitung der Schüler für 1 Tag enthalten sein?'
                                 containerRef={this.props.containerRef}
                                 checked={this.props.flags.prep_meeting}
                                 onChange={this.handleChange}
            />
            <ProgramFlagCheckbox name='parents_meeting'
                                 label='incl. Elterntreffen'
                                 description='Im Preis ist ein Treffen der Eltern enthalten, während die Schüler im Gastland sind.'
                                 containerRef={this.props.containerRef}
                                 checked={this.props.flags.parents_meeting}
                                 onChange={this.handleChange}
            />
            <ProgramFlagCheckbox name='after_meeting'
                                 label='incl. Nachbereitungstreffen'
                                 description='Im Preis ist ein Nachbereitungs-Treffen der Schüler nach Rückkehr enthalten.'
                                 containerRef={this.props.containerRef}
                                 checked={this.props.flags.after_meeting}
                                 onChange={this.handleChange}
            />

          </fieldset>
        </div>
      </React.Fragment>
    )
  }
}

ProgramFlagFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  flags: PropTypes.object.isRequired,
  containerRef: PropTypes.object.isRequired
}

export default ProgramFlagFilter
